import React from 'react';
import { connect } from 'react-redux';
import {
  ListGroupItem,
} from 'react-bootstrap';

import {
  tokenGetMetadata,
} from '../util/thunks';

import BidCard from './ui/BidCard';

class LosingAuction extends React.Component {

  state = {
    bid: 0,
    highestBidAmount: 0,
    timeRemaining: 0,
  };

  componentWillMount() {
    this.props.tokenGetMetadata();
  }

  getThumbnailSrc = () => {
    if (this.props.metadata && this.props.ipfsUrl) {
      return `${this.props.ipfsUrl}/${this.props.metadata.image.split('://ipfs/').join('/')}`;
    } else {
      return '';
    }
  }

  render() {
    return (
      <div>

        {this.props.metadata &&
          <BidCard
            src={this.getThumbnailSrc()}
            auction={this.props.auction}
            metadata={this.props.metadata}
            bid={this.props.bid}
            status="losing" />
        }
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    metadata: state.tokenMetadata.paths[ownProps.auction.tokenURI],
    ipfsUrl: state.web3.ipfsUrl,
    bid: state.unclaimedBids.all[ownProps.auction.auctionIndex],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({

  tokenGetMetadata: () => {
    return dispatch(tokenGetMetadata(ownProps.auction.tokenURI));
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(LosingAuction);



// WEBPACK FOOTER //
// ./src/components/LosingAuction.js